import $ from 'jquery';
import 'babel-polyfill';

class Logo {

  constructor() {

    this.colors = {
      1: 'red-orange',
      2: 'green',
      3: 'blue',
    };

    this.hovering = false;

    this.$logoWrapper = $('.header-logo figure');

    this.$shapesWrapper = $('<div class="shapes-wrapper"/>');

    this.addLogoShapes();

    this.convertImgToSvg();

    this.addHoverListener();

    $(window).on('WindowResize', () => this.scaleShapes());

  }

  addHoverListener() {

    this.$logoWrapper.on('mouseenter', () => this.hoverAction());

  }

  addLogoShapes() {

    const themePath = this.$logoWrapper.data('themePath');
    const randomColor = this.colors[this.randomNumberGuide(1, 3)];
    const plotPoints = this.randomizePlotPoints();

    for (const [key, value] of Object.entries(plotPoints)) {

      let $newImg = $(`<img>`);

      $newImg
        .addClass(`svg logo-shapes ${randomColor}`)
        .attr('src', `${themePath}/assets/img/logo-shapes-0${key}.svg`)
        .css({
          top: value.y,
          left: value.x,
          width: value.width,
        });

      this.$shapesWrapper.append($newImg);

    }

    this.$logoWrapper.append(this.$shapesWrapper);

  }

  convertImgToSvg() {

    const $svgs = $('img.svg');

    if (!$svgs.length) {
      return;
    }

    $svgs.each((index, element) => {

      const $img = $(element);

      $img.removeClass('header-logo-img');

      const imgURL = $img.attr('src');
      const classes = $img.attr('class');
      const styles = $img.attr('style');

      $.get(imgURL, (data) => {

        let $svg = $(data).find('svg');

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg
          .removeAttr('xmlns:a')
          .attr('class', classes)
          .attr('style', styles);

        // Check if the viewport is set, if the viewport is not set the SVG won't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', `0 0 ${$svg.attr('height')} ${$svg.attr('width')}`);
        }

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');

    });

  }

  hoverAction() {

    const plotPoints = this.randomizePlotPoints();
    const $svgShapes = $('.logo-shapes', this.$logoWrapper);

    $svgShapes.each((index, element) => {

      const index1 = index + 1;

      $(element).css({
        top: plotPoints[index1].y,
        left: plotPoints[index1].x,
      });

    });

  }

  randomNumberGuide(min, max) {

    return Math.floor(Math.random() * (max - min + 1) + min);

  }

  randomizePlotPoints() {

    return {
      1: {
        y: this.randomNumberGuide(-3, 3),
        x: this.randomNumberGuide(-5, 2),
        width: 22,
      },
      2: {
        y: this.randomNumberGuide(-3, 3),
        x: this.randomNumberGuide(142, 149),
        width: 49,
      },
      3: {
        y: this.randomNumberGuide(-3, 3),
        x: this.randomNumberGuide(260, 267),
        width: 49,
      },
      4: {
        y: this.randomNumberGuide(-3, 3),
        x: this.randomNumberGuide(375, 385),
        width: 17,
      },
      5: {
        y: this.randomNumberGuide(26, 32),
        x: this.randomNumberGuide(502, 509),
        width: 44,
      },
    };

  }

  scaleShapes() {

    let scale = this.$logoWrapper.width() / 600;

    this.$shapesWrapper.css('transform', `scale(${scale})`);

  }

}
new Logo();
